module.exports = __webpack_public_path__ + "static/media/pep_logo.52d02d22.svg";